export default __webpack_public_path__ + "static/media/drive_thru.1ee09936.svg";